import * as React from 'react';
import CouncilService from './CouncilService';
import H2 from 'src/components/general/headings/H2';
import Libraries from './Libraries';
import Parks from './Parks';
import Roads from './Roads';

const ExpenditureSection = () => (
  <section className="py-4 blue-gradient">
    <div className="container">
      <div className="row mt-6 mb-16">
        <H2>What does my council spend money on?</H2>
      </div>
    </div>
    <Roads />
    <Libraries />
    <Parks />
    <CouncilService />
  </section>
);

export default ExpenditureSection;



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/index.tsx